import {Field, Formik, Form, ErrorMessage, useFormik} from 'formik';
import React, {useState, useEffect, useContext} from 'react';
import GroupRadioButton from '../../../common-scripts/CustomFields/GroupRadioButton';
import * as Yup from 'yup';
import {NumberToLetter} from 'convertir-nombre-lettre';
import AutoSubmitFormik from '../../../common-scripts/Helpers/AutoSubmitFormik'
import {AppContext} from '../Context';
import AutoCompletePostalCode from '../../../common-scripts/CustomFields/AutoCompletePostalCode';
import DatePicker from '../../../common-scripts/CustomFields/DatePicker';
import UtilFunctions from "../../../common-scripts/Helpers/Utils";
import { isValidNumberForRegion } from 'libphonenumber-js';


const capitalize = s => s && s[0].toUpperCase() + s.slice(1)

/**
 * Personne à prévenir component
 *
 * @param id
 * @param personNumber
 * @param person
 * @param onValidPerson
 * @param onDelePerson
 * @returns {JSX.Element}
 * @constructor
 */
const PersonToPrevent = ({id, personNumber, person, onValidPerson, onDelePerson}) => {
	const {referencesUrls} = useContext(AppContext);
	const initialValues = person
	const onSubmit = values => {
		onValidPerson(id, values);
	}

	const phoneRegExp = /^\d{10}$/;
	const nameRegExp = /^[a-zA-ZÀ-ÿ]+(?:[ \-][a-zA-ZÀ-ÿ]+)*$/;

	const validationSchema = Yup.object().shape({
		civility: Yup.string().required('Merci de renseigner la civilité'),
		firstName: Yup.string().required('Merci de renseigner le prénom')
		.matches(
			nameRegExp,
			'Le nom entré est invalide'
		),
		lastName: Yup.string().required('Merci de renseigner le nom').matches(
			nameRegExp,
			'Le nom entré est invalide'
		),
		birthName: Yup.string().notRequired().matches(
			nameRegExp,
			'Le nom entré est invalide'
		),
		birthDate: Yup.date().required('Merci de renseigner la date de naissance'),
		email: Yup.string().notRequired().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Veuillez entrer une adresse email valide'),
		phone: Yup.string().matches(phoneRegExp, 'Format saisi invalide : votre numéro de téléphone doit contenir 10 chiffres.').required('Merci de renseigner le téléphone')
		.test({
			name: 'is-valid-fr-phone',
			test: value => value && isValidNumberForRegion(value.toString(), 'FR'),
			message: 'Le numéro de téléphone n\'est pas valide'
		}),
		address: Yup.string().required('Merci de renseigner l\'adresse'),
		placeOf: Yup.string().notRequired(),
		postalCode: Yup.string().required('Merci de renseigner le code postal'),
		city: Yup.string().required('Merci de renseigner la Ville'),

	});

	const checkFormValide = (action, status, values) => {

		//  console.log(action,status,values)

	}
	const onPostalCodeChange = (referentiels, cityName, postalCodeName, formik) => {

		formik.setFieldValue(postalCodeName, referentiels.postal_code);
		formik.setFieldValue(cityName, referentiels.city_name);
		formik.setTouched({...formik.touched, [postalCodeName]: true, [cityName]: true});

	}


	return <>
		<Formik
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={onSubmit}>

			{
				(formik) => {
					return <Form>
						<div className="bloc question picto valid under-ligne ">

							<h2 className="title "> {personNumber == 1 ? 'Première ' : capitalize(NumberToLetter(personNumber) + 'ième ')} personne
								à prévenir :
								{id > 0 && <span onClick={onDelePerson} className='delete'>
                                                    <i className="fa fa-times"></i>
                                                </span>
								}
							</h2>

						</div>
						<div className="bloc question picto valid under-ligne ">
							<div className="form-group  ">
								<label className="control-label" htmlFor="civility">Civilité : </label>
								<div className="container-input">
									<div role="group" className="btn-group btn-group-radio">
										<label className="bouton-form-radio">
											<Field value={'Madame'} className="valid-required" name="civility"
												   type="radio" title="Civilité"/>
											Madame
										</label>

										<label className="bouton-form-radio">
											<Field value={'Monsieur'} className="valid-required" name="civility"
												   type="radio" title="Civilité"/>
											Monsieur
										</label>
									</div>
								</div>
								<ErrorMessage
									name="civility"
									component="span"
									className="msg-error"
								/>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="firstName">Prénom : </label>
								<div className="container-input">
									<Field className="form-control" name="firstName" type="text"
										   placeholder="Saisissez le prénom  " title="prénom "/>
									<ErrorMessage
										name="firstName"
										component="span"
										className="msg-error"
									/>
								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="lastName">Nom : </label>
								<div className="container-input">
									<Field className="form-control" name="lastName" type="text"
										   placeholder="Saisissez le nom  " title="Saisissez le nom  "/>
									<ErrorMessage
										name="lastName"
										component="span"
										className="msg-error"
									/>
								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="birthName">Nom de naissance (facultatif) : </label>
								<div className="container-input">
									<Field className="form-control" name="birthName" type="text"
										   placeholder="Saisissez le nom de naissance  "
										   title="Saisissez le nom de naissance "/>
									<ErrorMessage
										name="birthName"
										component="span"
										className="msg-error"
									/>
								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="birthDate">Date de naissance : </label>
								<div className="container-input">
									<DatePicker className="form-control"
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
												handleBlur={() => {
													formik.setFieldTouched('birthDate', true)}}
												value={formik.values.birthDate}
												name="birthDate" type="date" title="Saisissez la Date de naissance "/>

								<ErrorMessage
									name="birthDate"
									component="span"
									className="msg-error"
								/>
								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="phone">Téléphone : </label>
								<div className="container-input">
									<Field className="form-control" name="phone" type="tel"
										   title="Saisissez le numéro de téléphone "/>
									<ErrorMessage
										name="phone"
										component="span"
										className="msg-error"
									/>
								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="email">E-mail : </label>
								<div className="container-input">
									<Field className="form-control" name="email" type="email"
										   placeholder="Saisissez l' email" title="Saisissez l' email"/>
									<ErrorMessage
										name="email"
										component="span"
										className="msg-error"
									/>
								</div>
							</div>

							<h2 className="title">Adresse

							</h2>
							<div className="form-group ">
								<label className="control-label" htmlFor="address">Adresse : </label>
								<div className="container-input">
									<Field className="form-control" name="address" type="text"
										   placeholder="Saisissez l'adresse " title="Adresse "/>
									<ErrorMessage
										name="address"
										component="span"
										className="msg-error"
									/>
								</div>
							</div>

							<div className="form-group ">
								<label className="control-label" htmlFor="placeOf">Lieu-dit (facultatif) : </label>
								<div className="container-input">
									<Field className="form-control" name="placeOf" type="text"
										   placeholder="Saisissez Lieu-dit " title="Lieu-dit "/>
									<ErrorMessage
										name="placeOf"
										component="span"
										className="msg-error"
									/>
								</div>
							</div>


							<div className="form-group  ">
								<label className="control-label" htmlFor="postalCode">Code postal : </label>
								<div className="container-input">
									<AutoCompletePostalCode oldValue={formik.values.postalCode}
															onPostalCodeChange={onPostalCodeChange} formik={formik}
															cityName="city" postalCodeName="postalCode"
															refUrl={referencesUrls.referentiel}/>
									{formik.errors.postalCode && formik.touched.postalCode ?
										<span className='msg-error'>{formik.errors.postalCode}</span> : null}
								</div>
							</div>
							<input hidden={true} onBlur={formik.handleBlur} onChange={formik.handleChange}
								   value={formik.values.postalCode} name="postalCode" id="postalCode"/>

							<div className="form-group ">
								<label className="control-label" htmlFor="city">Ville : </label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange} value={formik.values.city} name="city"
										   type="text" placeholder="Saisissez votre ville "
										   title="Saisissez votre ville "/>
								</div>
							</div>
						</div>
						<AutoSubmitFormik onReadyStateChange={checkFormValide} formik={formik} debounceMs={1000}/>
					</Form>
				}
			}
		</Formik>
	</>;
};

/**
 * Step Désignation du mandataire
 *
 * @param texteInfos
 * @param userData
 * @param checkReadyForSaving
 * @returns {JSX.Element}
 * @constructor
 */
const StepDesignation = ({texteInfos, userData, checkReadyForSaving}) => {
	const {currentStep, dispatchStepEvent, datas, setdatas, referencesUrls} = useContext(AppContext);

	const initialValues = (userData != undefined || userData != null) ? userData : {
		mandator: {
			type: '',
			procheInfos: {
				civility: '',
				firstName: '',
				lastName: '',
				birthName: '',
				birthDate: '',
				email: '',
				phone: '',
				address: '',
				placeOf: '',
				postalCode: '',
				city: ''
			}
		},
		designPerson: '',
		personsToPrevent: []
	}

	const [designPersons, setdesignPersons] = useState([
		{is_selected: false, libelle: 'Oui', icon_code: 'oui', infobulle: ''},
		{is_selected: false, libelle: 'Non', icon_code: 'non', infobulle: ''},

	].map((data) => {
		if (data.libelle == initialValues.designPerson)
			return {...data, is_selected: true}
		else
			return data;

	}));
	const [designedPerson, setdesignedPerson] = useState(initialValues.mandator.type == '' ? null : initialValues.mandator.type);

	const phoneRegExp = /^\d{10}$/
	const nameRegExp = /^[a-zA-ZÀ-ÿ]+(?:[ \-][a-zA-ZÀ-ÿ]+)*$/;

	const validationSchema = Yup.object({
		mandator: Yup.object().shape({
			type: Yup.string().required('Merci de  désigner la qualité du mandataire '),
			procheInfos: Yup.object().shape({
				civility: Yup.string().notRequired(),
				firstName: Yup.string().notRequired(),
				lastName: Yup.string().notRequired(),
				birthName: Yup.string().notRequired(),
				birthDate: Yup.date().notRequired(),
				email: Yup.string().notRequired(),
				phone: Yup.string().notRequired(),
				address: Yup.string().notRequired(),
				placeOf: Yup.string().notRequired(),
				postalCode: Yup.string().notRequired(),
				city: Yup.string().notRequired(),
			}).when('type', {
				is: 'Un proche',
				then: Yup.object().shape({
					civility: Yup.string().required('Merci de renseigner la Civilité'),
					firstName: Yup.string().required('Merci de renseigner le Prénom').matches(
						nameRegExp,
						'Le nom entré est invalide'
					),
					lastName: Yup.string().required('Merci de renseigner le Nom').matches(
						nameRegExp,
						'Le nom entré est invalide'
					),
					birthName: Yup.string().notRequired().matches(
						nameRegExp,
						'Le nom entré est invalide'
					),
					birthDate: Yup.date().required('Merci de renseigner la date de naissance'),
					email: Yup.string().required('Merci de renseigner l\'email ').matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Veuillez entrer une adresse email valide'),
					phone: Yup.string().matches(phoneRegExp, 'Format saisi invalide : votre numéro de téléphone doit contenir 10 chiffres.').required('Merci de renseigner le téléphone')
					.test({
						name: 'is-valid-fr-phone',
						test: value => value && isValidNumberForRegion(value.toString(), 'FR'),
						message: 'Le numéro de téléphone n\'est pas valide'
					}),
					address: Yup.string().notRequired(),
					placeOf: Yup.string().notRequired(),
					postalCode: Yup.string().notRequired(),
					city: Yup.string().notRequired(),
				})
			}),
		}),
		designPerson: Yup.string().required('Requis'),
		personsToPrevent: Yup.array().of(
			Yup.object().shape({
				civility: Yup.string().required('Merci de renseigner la Civilité'),
				firstName: Yup.string().required('Merci de renseigner le Prénom').matches(
					nameRegExp,
					'Le nom entré est invalide'
				),
				lastName: Yup.string().required('Merci de renseigner le Nom').matches(
					nameRegExp,
					'Le nom entré est invalide'
				),
				birthName: Yup.string().matches(
					nameRegExp,
					'Le nom entré est invalide'
				),
				birthDate: Yup.date().notRequired(),
				email: Yup.string().notRequired().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Veuillez entrer une adresse email valide'),
				phone: Yup.string().required('Merci de renseigner le Téléphone').test({
					name: 'is-valid-fr-phone',
					test: value => value && isValidNumberForRegion(value.toString(), 'FR'),
					message: 'Le numéro de téléphone n\'est pas valide'
				}),
				address: Yup.string().required('Merci de renseigner l\'adresse'),
				placeOf: Yup.string(),
				postalCode: Yup.string().required('Merci de renseigner le Code postal'),
				city: Yup.string().required('Merci de renseigner la Ville'),
			})
		).when('designPerson', {
			is: 'Non',
			then: Yup.array().notRequired()
		})
	});
	const [procheCivility, setprocheCivility] = useState(initialValues.mandator.procheInfos.civility == '' ? null : initialValues.mandator.procheInfos.civility);

	const formik = useFormik({
		validationSchema: validationSchema,
		initialValues: initialValues
	})

	/**
	 * On change groupRadio
	 *
	 * @param {number} id
	 * @param {string} group
	 */
	const onChangeGroupRadio = (id, group) => {
		switch (group) {
			case 'designPersons':
				setdesignPersons(
					designPersons.map((data, index) => {
							if (index == id) {

								formik.setFieldValue('designPerson', data.libelle)
								formik.setTouched({...formik.touched, 'designPerson': true})
								if (data.libelle == 'Non') {
									formik.setFieldValue('personsToPrevent', ([]))
								} else {
									if (formik.values.personsToPrevent.length < 1) {
										addFormPreventPerson();
									}
								}
								return {...data, is_selected: true}
							} else {
								return {...data, is_selected: false}
							}

						}
					)
				);
				break;
		}
	}

	/**
	 * OnChange Design Person (Funecap IDF or Un proche)
	 *
	 * @param e
	 */
	const onChangeDesignPersons = (e) => {
		setdesignedPerson(e.target.value);
		formik.setFieldValue('mandator.type', e.target.value);
		formik.setTouched({...formik.touched, 'mandator.type': true})

	}

	/**
	 * add item to personsToPrevent array
	 */
	const addFormPreventPerson = () => {
		let oldData = formik.values.personsToPrevent;
		formik.setFieldValue('personsToPrevent', ([...oldData, {
			civility: '',
			firstName: '',
			lastName: '',
			birthName: '',
			birthDate: '',
			email: '',
			phone: '',
			address: '',
			placeOf: '',
			postalCode: '',
			city: ''
		}]))
	}

	/**
	 * Remove person to prevent
	 *
	 * @param {number} i
	 */
	const removeFormPreventPerson = (i) => {
		let oldData = formik.values.personsToPrevent;
		let newFormPersonValues = [...oldData];
		newFormPersonValues.splice(i, 1);
		formik.setFieldValue('personsToPrevent', newFormPersonValues);
		formik.setTouched({...formik.touched, 'personsToPrevent': true})
	}

	/**
	 * Check if values filled in Person To prevent form are valid
	 *
	 * @param id
	 * @param values
	 */
	const onValidPreventPersons = (id, values) => {

		let oldData = formik.values.personsToPrevent;
		oldData[id] = values;
		formik.setFieldValue('personsToPrevent', oldData);
		formik.setFieldTouched('personsToPrevent', true);
		valideStepForm();


	}

	/**
	 * On postalCode Change
	 *
	 * @param referentiels
	 * @param cityName
	 * @param postalCodeName
	 */
	const onPostalCodeChange = (referentiels, cityName, postalCodeName) => {

		formik.setFieldValue(postalCodeName, referentiels.postal_code);
		formik.setFieldValue(cityName, referentiels.city_name);
		formik.setTouched({...formik.touched, postalCodeName: true});
		formik.setTouched({...formik.touched, cityName: true});

	}

	/**
	 * Check if values filled in step are valids
	 */
	const valideStepForm = () => {
		checkReadyForSaving(Object.keys(formik.touched).length > 0);
		formik.validateForm().then((res) => {
			datas[2] = formik.values;
			setdatas(datas);
			if (Object.keys(res).length == 0) {
				dispatchStepEvent('SET_STEP_READY', true);
			} else {
				dispatchStepEvent('SET_STEP_READY', false)
			}
		})
	}

	/**
	 * When civility changes
	 *
	 * @param e
	 */
	const onChangeCivility = (e) => {
		setprocheCivility(e.target.value);
		formik.setFieldValue('mandator.procheInfos.civility', e.target.value);
		formik.setTouched({...formik.touched, 'mandator.procheInfos.civility': true})
	}

	useEffect(() => {

		valideStepForm();

	}, [formik.values])


	return <>
		<div id="step-3" className="step-form">

			<div className="card-banner info" dangerouslySetInnerHTML={{__html: texteInfos}}>

			</div>

			<div className="form-card">
				<div className="card-header">
					Je désigne en qualité de mandataire :
				</div>
				<div className="card-body">

					<div className="form-group block  under-ligne">


						<div role="group" className="btn-group btn-group-radio-column btn-group-radio">
							<label className="bouton-form-radio">
								<input readOnly={true} defaultValue={'Un proche'}
									   checked={designedPerson === "Un proche"}
									   onChange={onChangeDesignPersons} className="" name="mandator" type="radio"
									   title="Mandataire"/>
								Un proche
							</label>

							<label className="bouton-form-radio">
								<input readOnly={true} defaultValue={'Funecap IDF'}
									   checked={designedPerson === "Funecap IDF"}
									   onChange={onChangeDesignPersons}
									   className=""
									   name="mandator" type="radio" title="Mandataire"/>
								Funecap IDF
							</label>

						</div>

					</div>

					<input hidden={true} onBlur={formik.handleBlur} onChange={formik.handleChange}
						   value={formik.values.mandator.type} name="mandator.type" id="mandator"/>

					{
						designedPerson == 'Un proche' && <div className="bloc question picto valid">
							<h2 className="title ">Désignation du mandataire :

							</h2>
							<div className="form-group  ">
								<label className="control-label" htmlFor="civility">Civilité : </label>
								<div className="container-input">
									<div role="group" className="btn-group btn-group-radio">
										<label className="bouton-form-radio">
											<input

												readOnly={true}
												defaultValue={'Madame'}
												checked={procheCivility === "Madame"}
												onChange={onChangeCivility}

												className="" type="radio" title="Civilité"/>
											Madame
										</label>

										<label className="bouton-form-radio">
											<input

												readOnly={true}
												defaultValue={'Monsieur'}
												checked={procheCivility === "Monsieur"}
												onChange={onChangeCivility}

												type="radio" title="Civilité"/>
											Monsieur
										</label>
									</div>
								</div>
								<input hidden={true} onBlur={formik.handleBlur} onChange={formik.handleChange}
									   value={formik.values.mandator.procheInfos.civility}
									   name="mandator.procheInfos.civility" id="otherDispositions.typeOfCoffin"/>

							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="firstName">Prénom : </label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange}
										   value={formik.values.mandator.procheInfos.firstName}
										   name="mandator.procheInfos.firstName" type="text"
										   placeholder="Saisissez le Prénom  " title="Prénom "/>

									{formik.errors.mandator?.procheInfos?.firstName && formik.touched.mandator?.procheInfos?.firstName ?
										<span className='msg-error'>{formik.errors.mandator.procheInfos.firstName}</span> : null}
								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="lastName"> Nom : </label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange}
										   value={formik.values.mandator.procheInfos.lastName}
										   name="mandator.procheInfos.lastName" type="text" placeholder="Saisissez le Nom  "
										   title="Saisissez le nom  "/>

									{formik.errors.mandator?.procheInfos?.lastName && formik.touched.mandator?.procheInfos?.lastName ?
										<span className='msg-error'>{formik.errors.mandator.procheInfos.lastName}</span> : null}

								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="birthName">Nom de naissance (facultatif): </label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange}
										   value={formik.values.mandator.procheInfos.birthName}
										   name="mandator.procheInfos.birthName" type="text"
										   placeholder="Saisissez le nom de naissance  "
										   title="Saisissez le nom de naissance "/>

									{formik.errors.mandator?.procheInfos?.birthName && formik.touched.mandator?.procheInfos?.birthName ?
										<span className='msg-error'>{formik.errors.mandator.procheInfos.birthName}</span> : null}
								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="birthDate">Date de naissance : </label>
								<div className="container-input">
									<DatePicker className="form-control" onBlur={formik.handleBlur}
												onChange={formik.handleChange}
												handleBlur={() => {
													formik.setFieldTouched('mandator.procheInfos.birthDate', true);
												}}
												value={formik.values.mandator.procheInfos.birthDate}
												name="mandator.procheInfos.birthDate" type="date"
												placeholder="Date de naissance  " title="Saisissez la Date de naissance "/>

{formik.errors.mandator?.procheInfos?.birthDate && formik.touched.mandator?.procheInfos?.birthDate ?
										<span className='msg-error'>{formik.errors.mandator.procheInfos.birthDate}</span> : null}
								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="phone">Téléphone : </label>
								<div className="container-input">
									<input
										className="form-control"
										onBlur={formik.handleBlur}
										onChange={formik.handleChange}
										value={formik.values.mandator.procheInfos.phone}
										name="mandator.procheInfos.phone"
										type="tel"
										title="Saisissez le numéro de téléphone "
									/>

									{formik.errors.mandator?.procheInfos?.phone && formik.touched.mandator?.procheInfos?.phone ?
										<span className='msg-error'>{formik.errors.mandator.procheInfos.phone}</span> : null}
								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="email">E-mail : </label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange} value={formik.values.mandator.procheInfos.email}
										   name="mandator.procheInfos.email" type="email" placeholder="Saisissez l' email"
										   title="Saisissez l' email"/>

									{formik.errors.mandator?.procheInfos?.email && formik.touched.mandator?.procheInfos?.email ?
										<span className='msg-error'>{formik.errors.mandator.procheInfos.email}</span> : null}

								</div>
							</div>

							<h2 className="title">Adresse du mandataire

							</h2>

							<div className="form-group ">
								<label className="control-label" htmlFor="placeOf">Adresse : </label>
								<div className="container-input">
									<input
										className="form-control"
										onBlur={formik.handleBlur}
										onChange={formik.handleChange}
										value={formik.values.mandator.procheInfos.address}
										name="mandator.procheInfos.address"
										type="text"
										placeholder="Saisissez l'adresse "
										title="Adresse "
									/>
								</div>
							</div>

							<div className="form-group ">
								<label className="control-label" htmlFor="placeOf">Lieu-dit (facultatif) : </label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange} value={formik.values.mandator.procheInfos.placeOf}
										   name="mandator.procheInfos.placeOf" type="text" placeholder="Saisissez Lieu-dit "
										   title="Lieu-dit "/>

								</div>
							</div>
							<div className="form-group  ">
								<label className="control-label" htmlFor="postalCode">Code postal : </label>
								<div className="container-input">
									<AutoCompletePostalCode oldValue={formik.values.mandator?.procheInfos?.postalCode}
															onPostalCodeChange={onPostalCodeChange}
															cityName="mandator.procheInfos.city"
															postalCodeName="mandator.procheInfos.postalCode"
															refUrl={referencesUrls.referentiel}/>
									{formik.errors.mandator?.procheInfos?.postalCode && formik.touched.mandator?.procheInfos?.postalCode ?
										<span
											className='msg-error'>{formik.errors.mandator?.procheInfos?.postalCode}</span> : null}
								</div>
							</div>
							<input hidden={true} onBlur={formik.handleBlur} onChange={formik.handleChange}
								   value={formik.values.mandator.procheInfos.postalCode}
								   name="mandator.procheInfos.postalCode" id="mandator.procheInfos.postalCode"/>

							<div className="form-group ">
								<label className="control-label" htmlFor="city">Ville : </label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange} value={formik.values.mandator.procheInfos.city}
										   name="mandator.procheInfos.city" type="text" placeholder="Saisissez votre ville "
										   title="Saisissez votre ville "/>

								</div>
							</div>

						</div>
					}


				</div>

			</div>

			<div className="card-banner info">
				<p> Le moment venu, nous préviendrons du décès les personnes désignées dans le présent formulaire et
					leur transmettrons une copie du recueil des volontés. </p>
			</div>

			<div className="form-card">
				<div className="card-header">
					Souhaitez-vous désigner une personne à prévenir ?
				</div>
				<div className="card-body">

					<div className="bloc question picto valid  under-ligne">
						<GroupRadioButton onChange={onChangeGroupRadio} group={'designPersons'} radios={designPersons}/>
					</div>
					<input hidden={true} onBlur={formik.handleBlur} onChange={formik.handleChange}
						   value={formik.values.designPerson} name="designPerson" id="designPerson"/>


					{
						designPersons.map((choice, index) => {

							if (choice.is_selected && choice.libelle == 'Oui') {

								return <div key={index}>
									{formik.values.personsToPrevent.map((preventPerson, index) => {
										return <PersonToPrevent onDelePerson={() => removeFormPreventPerson(index)}
																key={index} id={index} personNumber={index + 1}
																person={preventPerson}
																onValidPerson={onValidPreventPersons}/>
									})}
									<div>

										{formik.values.personsToPrevent.length < 2 &&
											<div style={{cursor: 'pointer'}} onClick={addFormPreventPerson}
												 className='flex center'>
												<i className="fa fa-plus"></i> <span style={{marginLeft: '10px'}}> Ajouter une personne</span>
											</div>}

									</div>

								</div>

							}
						})
					}
					<input hidden={true} onBlur={formik.handleBlur} onChange={formik.handleChange}
						   value={formik.values.personsToPrevent} name="personsToPrevent[]" id="personsToPrevent"/>

				</div>

			</div>


		</div>


	</>;
};

export default StepDesignation;

